// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingDots_root__pINn2","blink":"LoadingDots_blink__T7X7K"};